import React from 'react'
import {Grid} from 'semantic-ui-react'

import {User} from './User'

export const Responsible = () => {

    const userData = JSON.parse(sessionStorage.getItem('Data'))

    return (
        <Grid>
            <Grid.Row columns={"equal"}>
                <Grid.Column>
                    <User item={userData.place} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}